import { Component, OnInit, Input, Output, HostListener, EventEmitter } from '@angular/core';
import { CourtCase } from './../../shared/court-case';
import { CivilCase} from '../../civil/civil-case';
import { HtmlUtil } from './../../shared/html-util';

@Component({
  selector: 'app-cart-pleads-grid',
  templateUrl: './cart-pleads-grid.component.html',
  styleUrls: ['./cart-pleads-grid.component.less']
})
export class CartPleadsGridComponent implements OnInit {
   @Input() case: CivilCase;
   @Input() gridType: string;  // table or ag-grid
   @Input() caseRowIndex: number;
   @Input() maxDisplayRows: number;
   @Input() bgHighlighted: boolean;
   @Input() rowBeingShown: boolean;
   @Input() rowToBeHidden = false;
   @Output() onPleadingClosed = new EventEmitter<number>();

   pleadingTableDataList: any[];

   constructor() {}

   ngOnInit() {
      if (!this.gridType) {
          this.gridType = 'table';
      }

     // set table list data
     this.pleadingTableDataList = this.case.getPleadingsIssuesDisplayList();
   }

   scrollbarShouldBeShown(): boolean {
    return this.pleadingTableDataList.length > this.maxDisplayRows;
  }

  /**
    * check on the transition end event and emit the onPleadingClosed event
    * @param event
    */
   @HostListener('window:transitionend', ['$event'])
   onTransitionEnd($event) {
      if (this.rowToBeHidden) {
          this.onPleadingClosed.emit(this.caseRowIndex);
          this.rowToBeHidden = false;
      }
   }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/cart/cart-pleads-grid/cart-pleads-grid.component.ts